const th = {
    '例子': 'ตัวอย่าง',
}
export default th;